module.exports = __webpack_public_path__ + "static/media/bbond-512.50e5e9c8.png";